module.exports = __webpack_public_path__ + "static/media/eyeclose.1909b1de.svg";